module.exports = __webpack_public_path__ + "static/media/nosubimg.3e237ad1.png";